import React from "react";
import { forgotPassword, forgotPasswordSubmit } from "../../../utils/utils";
import { Button, Modal } from "react-bootstrap";
import { browserHistory } from "react-router";
import AppJS from "../../../assets/app/AppJS";
import AppCSS from "../../../assets/app/AppCSS";

function ForgotPassword() {
  const [username, setUsername] = React.useState("");
  const [code, setCode] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [isOpenModal, setIsOpenModal] = React.useState(false);

  React.useEffect(() => {
    document.title = "Forgot Password";
  }, []);

  const openModal = () => {
    setIsOpenModal(true);
  };
  const closeModal = () => {
    setIsOpenModal(false);
  };

  const inputDict = {
    email: setUsername,
    userCode: setCode,
    userNewPassword: setNewPassword,
  };

  function handleForgotPasswordConfirm(e) {
    e.preventDefault();
    const resp = forgotPasswordSubmit(username, code, newPassword);
    resp
      .then((data) => {
        console.log(data);
        closeModal();
        alert("Your passoword has been reset! Redirecting to sign in!");
        browserHistory.push("/app/signin");
      })
      .catch((err) => {
        console.error(err);
        alert(err);
      });
  }

  function handleForgotPassword(e) {
    e.preventDefault();
    console.log("username", username);
    const resp = forgotPassword(username);
    resp
      .then((data) => {
        console.log("Forgot Password Data", data);
        alert("Password Reset Instructions sent! Redirecting you to signin");
        browserHistory.push("/app/signin");
      })
      .catch((err) => {
        console.log("Forgot Password Error", err);
        alert(err.message);
      });
  }

  function handleChange(e) {
    inputDict[e.target.name](e.target.value.trim());
  }
  return (
    <>
      <AppJS />
      <AppCSS />

      <div className="bg-black signup__main">
        <div className="card bg-dark col-lg-4 col-md-6 col-sm-12">
          <div className="card-body">
            <h2 className="card-title text-center text-white mb-2">
              Reset Password
            </h2>
            <form className="text-center">
              <div class="form-group">
                <label
                  for="exampleInputEmail1"
                  className="text-white text-center"
                >
                  Please enter your email address
                </label>
                <input
                  class="form-control form-control-lg mb-3 bg-dark text-white"
                  type="email"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="Enter email"
                  onChange={(e) => handleChange(e)}
                  name="email"
                ></input>
                <button
                  type="submit"
                  class="btn btn-primary btn-lg btn-block"
                  onClick={(e) => {
                    handleForgotPassword(e);
                  }}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>

          <Modal
            show={isOpenModal}
            onHide={closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton className="bg-dark ">
              <Modal.Title className="model-header">
                Reset your Password
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark">
              <p className="text-white">
                Please check your email for the verification code. Enter the
                verification code along with the new password below.
              </p>
              <input
                class="form-control form-control-lg mb-3 bg-dark text-white"
                type="text"
                placeholder="Enter the Verification Code"
                name="userCode"
                onChange={(e) => {
                  handleChange(e);
                }}
              ></input>
              <input
                class="form-control form-control-lg mb-3 bg-dark text-white"
                type="password"
                placeholder="Enter the new Password"
                name="userNewPassword"
                onChange={(e) => {
                  handleChange(e);
                }}
              ></input>
            </Modal.Body>
            <Modal.Footer className="bg-dark">
              <Button
                variant="secondary"
                onClick={handleForgotPasswordConfirm}
                className="btn btn-primary btn-lg"
              >
                Reset Password
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;
